export const leadStory = {
  badge: 'Top story',
  date: '29 July 2026',
  title: 'Our Grade 9 team took second place at the Lagos State Science Fair',
  body: 'Four students spent eleven Friday afternoons building a low-cost water filter from clay and rice husk. It removed 96% of turbidity in testing, and the judges asked to keep the prototype.',
  photoCaption: 'Lead news photo',
};

export const newsItems = [
  {
    date: '24 July 2026',
    title: 'The library passed 9,000 books',
    body: 'A donation from the class of 2011 added 640 titles, mostly in Yoruba and Igbo.',
  },
  {
    date: '16 July 2026',
    title: 'Ms. Adaeze marks nine years',
    body: 'She has now taught 214 children through the Toddler Room. Several of their siblings are in Grade 8.',
  },
  {
    date: '9 July 2026',
    title: 'New shade over the Toddler garden',
    body: 'Outdoor play now runs through the hottest part of the day, every day.',
  },
  {
    date: '2 July 2026',
    title: 'Grade 10 results: 100% pass',
    body: 'Every one of our 38 leavers passed, and 31 went on to their first-choice school.',
  },
];

export const upcomingEvents = [
  {
    day: '04',
    month: 'AUG',
    title: 'Open visit morning',
    detail: '10:00 · Toddler Room and Primary. No booking needed.',
  },
  {
    day: '08',
    month: 'AUG',
    title: 'September offer letters',
    detail: 'All decisions sent by end of day.',
  },
  {
    day: '30',
    month: 'AUG',
    title: 'Intake closes',
    detail: 'Last day to apply for a September place.',
  },
  {
    day: '07',
    month: 'SEP',
    title: 'First day of term',
    detail: 'Teachers call every new family the evening before.',
  },
  {
    day: '19',
    month: 'SEP',
    title: 'Sports day',
    detail: 'Whole school, all ages, parents welcome.',
  },
];
